module.exports = __webpack_public_path__ + "templates.shopline_product_review-3d3e2e5b.html";